module.exports = __webpack_public_path__ + "static/img/shiye_img8@2x(1).ba37edbe.jpg";